import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import AnimationRevealPage from "helpers/AnimationRevealPage.js";

import Hero from "components/hero/WeathWiseHero.js";
import About from "components/about/WeathWiseAbout.js";
import Features from "components/features/ThreeColWithSideImage.js";
import MainFeature from "components/features/TwoColWithTwoHorizontalFeaturesAndButton.js";
import FeatureStats from "components/features/ThreeColCenteredStatsPrimaryBackground.js";
import Testimonial from "components/testimonials/TwoColumnWithImageAndRating.js";
import FAQ from "components/faqs/SingleCol.js";
// import GetStarted from "components/cta/GetStartedLight.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import WeathWiseServices from "components/services/WeathWiseServices";
import WeathWiseLoanCal from "components/WeathWiseLoanCal";
import WeathwiseLoanApply from "components/WeathwiseLoanApply";
import WeathWiseContact from "components/WeathWiseContact";
import MapSection from "components/WeathWiseMap";

const HighlightedText = tw.span`text-primary-500`;

export default () => {
  return (
    <>
      <AnimationRevealPage>
        <Hero />
        <About />
        <Features />

        {/* Benefits */}
        {/* <MainFeature /> */}
        <Testimonial
          heading={
            <>
              Our Clients <HighlightedText>Love Us</HighlightedText>
            </>
          }
        />
        <FeatureStats />
        <WeathWiseServices />
        <WeathWiseLoanCal />
        <WeathwiseLoanApply />
        <FAQ
          heading={
            <>
              Any <HighlightedText>Questions ?</HighlightedText>
            </>
          }
        />
        <WeathWiseContact />
        <MapSection />
        <Footer />
      </AnimationRevealPage>
      <div tw="bg-[#171C28] py-4 px-4 sm:px-12 text-center text-sm text-gray-400">
        <p>
          Developed and Maintained by{" "}
          <a
            href="https://tgnsystems.org"
            target="_blank"
            tw="text-[#fc4414] hover:underline font-bold transition duration-300"
          >
            {" "}
            TGN SYSTEMS LTD
          </a>
        </p>
      </div>
    </>
  );
};
